import { useEffect, useState } from 'react';

import { Space } from '@/components/base';
import Input from '@/components/Inputs/Input';
import { useModalContext } from '@/components/Modal/Modal';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import useWorkspaceStore from '@/stores/WorkspaceStore';
import { getGorigasUrl } from '@/utils/integration';
import { generateRandomString } from '@/utils/util';

import { CompoundConnectModal } from '../../components/ConnectModal';

type Props = {
  initialSubdomain?: string;
};

export const GorgiasConnectModal = ({ initialSubdomain }: Props) => {
  const currWorkspace = useWorkspaceStore((state) => state.currWorkspace);
  const color = useColor();
  const { closeModal } = useModalContext();

  const [subdomain, setSubdomain] = useState(initialSubdomain || '');
  const [error] = useState<string | null>(null);

  useEffect(() => {
    setSubdomain(initialSubdomain || '');
  }, [initialSubdomain]);

  const handleConnectWorkspace = async () => {
    if (!currWorkspace) return;
    if (subdomain.trim() === '') return;

    const state = generateRandomString();
    sessionStorage.setItem(
      state,
      JSON.stringify({ workspaceAlias: currWorkspace.alias, subdomain }),
    );

    window.open(getGorigasUrl(subdomain, state));
    closeModal();
  };

  return (
    <CompoundConnectModal
      title="Connect Gorgias"
      description="Subdomain is required to connect to Gorgias"
      error={error}
      connectButtonDisabled={subdomain.trim() === ''}
      handleConnectWorkspace={handleConnectWorkspace}
    >
      <Typo type="label1" weight="m">
        Subdomain
      </Typo>
      <Space h="4px" />
      <Typo type="label2" color={color.gray700}>
        Enter the subdomain of your Gorgias URL.
      </Typo>
      <Space h="4px" />
      <Typo type="body2" color={color.gray700}>
        (ex. https://<b>your-subdomain</b>.gorgias.com)
      </Typo>
      <Space h="16px" />
      <Input
        placeholder="Subdomain"
        sizeType="m"
        value={subdomain}
        onChange={(e) => setSubdomain(e.target.value)}
      />
    </CompoundConnectModal>
  );
};
